import About from '../../modules/about/about'

const appRoutes = [
  {
    path: '/about',
    component: About,
  }
];

export default appRoutes